import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledSectionWrapper,
  StyledBox,
  BlogCenterTextPairing,
  StyledColumnDesktop,
  StyledButtonBox,
  StyledButton,
} from './ChooseExperiencesSection.styles';
import { CloudImage } from '@components/CloudImage';
import { registryPageData } from '@data-ts/pages/honeymoon-registry';

const publicCatalogSection = registryPageData.chooseExperiencesSection;
interface ChooseExperiencesSectionProps {}
export const ChooseExperiencesSection: React.FC<ChooseExperiencesSectionProps> = () => {
  return (
    <StyledSectionWrapper
      backgroundImageTop={'honeymoon-fund/mobile-experiences-top.jpg'}
      backgroundImageBottom={'honeymoon-fund/mobile-experiences-bottom.jpg'}
      as="section"
      id="Honeymoon_Experiences"
      marginTop={[0, 12]}
      marginBottom={14}
    >
      <Columns verticalAlign="center" marginTop={[8, 0]}>
        <Columns.Column width={6} mobile={12}>
          <StyledBox>
            <BlogCenterTextPairing
              alignment="left"
              eyebrow={publicCatalogSection.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h2"
              title={publicCatalogSection.title}
              titleVariant="hed56"
              titleColor="neutra6"
              titleTagName="h2"
              body={publicCatalogSection.feature}
              bodyVariant="dek24"
              bodyColor="neutra5"
              bodyTagName="p"
            />
            <StyledButtonBox marginTop={[8, 8]} marginBottom={[10, 0]}>
              <StyledButton
                id="honeymoonExperiencesGetStartedBtn"
                href={'https://withjoy.com/shop/catalog/5b325244-496e-594f-8dbb-a75608175dad'}
                forwardedAs={'a'}
                variant="primary"
                target="_blank"
              >
                {publicCatalogSection.getExploreExperiences}
              </StyledButton>
            </StyledButtonBox>
          </StyledBox>
        </Columns.Column>
        <StyledColumnDesktop offset={1} width={6} mobile={12}>
          <CloudImage src="honeymoon-fund/experiences-grid.jpg" width={'100%'} />
        </StyledColumnDesktop>
      </Columns>
    </StyledSectionWrapper>
  );
};
